module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "fb15");
/******/ })
/************************************************************************/
/******/ ({

/***/ "6b0d":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
// runtime helper for setting properties on components
// in a tree-shakable way
exports.default = (sfc, props) => {
    for (const [key, val] of props) {
        sfc[key] = val;
    }
    return sfc;
};


/***/ }),

/***/ "7e79":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "8875":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// addapted from the document.currentScript polyfill by Adam Miller
// MIT license
// source: https://github.com/amiller-gh/currentScript-polyfill

// added support for Firefox https://bugzilla.mozilla.org/show_bug.cgi?id=1620505

(function (root, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {}
}(typeof self !== 'undefined' ? self : this, function () {
  function getCurrentScript () {
    var descriptor = Object.getOwnPropertyDescriptor(document, 'currentScript')
    // for chrome
    if (!descriptor && 'currentScript' in document && document.currentScript) {
      return document.currentScript
    }

    // for other browsers with native support for currentScript
    if (descriptor && descriptor.get !== getCurrentScript && document.currentScript) {
      return document.currentScript
    }
  
    // IE 8-10 support script readyState
    // IE 11+ & Firefox support stack trace
    try {
      throw new Error();
    }
    catch (err) {
      // Find the second match for the "at" string to get file src url from stack.
      var ieStackRegExp = /.*at [^(]*\((.*):(.+):(.+)\)$/ig,
        ffStackRegExp = /@([^@]*):(\d+):(\d+)\s*$/ig,
        stackDetails = ieStackRegExp.exec(err.stack) || ffStackRegExp.exec(err.stack),
        scriptLocation = (stackDetails && stackDetails[1]) || false,
        line = (stackDetails && stackDetails[2]) || false,
        currentLocation = document.location.href.replace(document.location.hash, ''),
        pageSource,
        inlineScriptSourceRegExp,
        inlineScriptSource,
        scripts = document.getElementsByTagName('script'); // Live NodeList collection
  
      if (scriptLocation === currentLocation) {
        pageSource = document.documentElement.outerHTML;
        inlineScriptSourceRegExp = new RegExp('(?:[^\\n]+?\\n){0,' + (line - 2) + '}[^<]*<script>([\\d\\D]*?)<\\/script>[\\d\\D]*', 'i');
        inlineScriptSource = pageSource.replace(inlineScriptSourceRegExp, '$1').trim();
      }
  
      for (var i = 0; i < scripts.length; i++) {
        // If ready state is interactive, return the script tag
        if (scripts[i].readyState === 'interactive') {
          return scripts[i];
        }
  
        // If src matches, return the script tag
        if (scripts[i].src === scriptLocation) {
          return scripts[i];
        }
  
        // If inline source matches, return the script tag
        if (
          scriptLocation === currentLocation &&
          scripts[i].innerHTML &&
          scripts[i].innerHTML.trim() === inlineScriptSource
        ) {
          return scripts[i];
        }
      }
  
      // If no match, return null
      return null;
    }
  };

  return getCurrentScript
}));


/***/ }),

/***/ "8bbf":
/***/ (function(module, exports) {

module.exports = require("vue");

/***/ }),

/***/ "fb15":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  var currentScript = window.document.currentScript
  if (true) {
    var getCurrentScript = __webpack_require__("8875")
    currentScript = getCurrentScript()

    // for backward compatibility, because previously we directly included the polyfill
    if (!('currentScript' in document)) {
      Object.defineProperty(document, 'currentScript', { get: getCurrentScript })
    }
  }

  var src = currentScript && currentScript.src.match(/(.+\/)[^/]+\.js(\?.*)?$/)
  if (src) {
    __webpack_require__.p = src[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ var setPublicPath = (null);

// EXTERNAL MODULE: external {"commonjs":"vue","commonjs2":"vue","root":"Vue"}
var external_commonjs_vue_commonjs2_vue_root_Vue_ = __webpack_require__("8bbf");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader-v16/dist??ref--0-1!./src/components/Donut.vue?vue&type=template&id=b088dc58

var _hoisted_1 = ["title"];
function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_donut_sections = Object(external_commonjs_vue_commonjs2_vue_root_Vue_["resolveComponent"])("donut-sections");

  return Object(external_commonjs_vue_commonjs2_vue_root_Vue_["openBlock"])(), Object(external_commonjs_vue_commonjs2_vue_root_Vue_["createElementBlock"])("div", {
    class: "cdc-container",
    style: Object(external_commonjs_vue_commonjs2_vue_root_Vue_["normalizeStyle"])($options.placementStyles.container)
  }, [Object(external_commonjs_vue_commonjs2_vue_root_Vue_["createElementVNode"])("div", {
    class: "cdc",
    ref: "donut",
    style: Object(external_commonjs_vue_commonjs2_vue_root_Vue_["normalizeStyle"])($options.donutStyles)
  }, [Object(external_commonjs_vue_commonjs2_vue_root_Vue_["createVNode"])(_component_donut_sections, Object(external_commonjs_vue_commonjs2_vue_root_Vue_["mergeProps"])(Object(external_commonjs_vue_commonjs2_vue_root_Vue_["toHandlers"])($options.sectionListeners), {
    sections: $options.donutSections,
    "start-angle": $props.startAngle
  }), null, 16, ["sections", "start-angle"]), Object(external_commonjs_vue_commonjs2_vue_root_Vue_["createElementVNode"])("div", {
    class: "cdc-overlay",
    style: Object(external_commonjs_vue_commonjs2_vue_root_Vue_["normalizeStyle"])($options.overlayStyles)
  }, [Object(external_commonjs_vue_commonjs2_vue_root_Vue_["createElementVNode"])("div", {
    class: "cdc-text",
    style: Object(external_commonjs_vue_commonjs2_vue_root_Vue_["normalizeStyle"])($options.donutTextStyles)
  }, [Object(external_commonjs_vue_commonjs2_vue_root_Vue_["renderSlot"])(_ctx.$slots, "default", {}, function () {
    return [Object(external_commonjs_vue_commonjs2_vue_root_Vue_["createTextVNode"])(Object(external_commonjs_vue_commonjs2_vue_root_Vue_["toDisplayString"])($props.text), 1)];
  })], 4)], 4)], 4), Object(external_commonjs_vue_commonjs2_vue_root_Vue_["renderSlot"])(_ctx.$slots, "legend", {}, function () {
    return [$props.hasLegend ? (Object(external_commonjs_vue_commonjs2_vue_root_Vue_["openBlock"])(), Object(external_commonjs_vue_commonjs2_vue_root_Vue_["createElementBlock"])("div", {
      key: 0,
      class: "cdc-legend",
      style: Object(external_commonjs_vue_commonjs2_vue_root_Vue_["normalizeStyle"])($options.placementStyles.legend)
    }, [(Object(external_commonjs_vue_commonjs2_vue_root_Vue_["openBlock"])(true), Object(external_commonjs_vue_commonjs2_vue_root_Vue_["createElementBlock"])(external_commonjs_vue_commonjs2_vue_root_Vue_["Fragment"], null, Object(external_commonjs_vue_commonjs2_vue_root_Vue_["renderList"])($options.legend, function (item, idx) {
      return Object(external_commonjs_vue_commonjs2_vue_root_Vue_["openBlock"])(), Object(external_commonjs_vue_commonjs2_vue_root_Vue_["createElementBlock"])("span", {
        class: "cdc-legend-item",
        key: idx,
        title: item.percent
      }, [Object(external_commonjs_vue_commonjs2_vue_root_Vue_["createElementVNode"])("span", {
        class: "cdc-legend-item-color",
        style: Object(external_commonjs_vue_commonjs2_vue_root_Vue_["normalizeStyle"])(item.styles)
      }, null, 4), Object(external_commonjs_vue_commonjs2_vue_root_Vue_["createElementVNode"])("span", null, Object(external_commonjs_vue_commonjs2_vue_root_Vue_["toDisplayString"])(item.label), 1)], 8, _hoisted_1);
    }), 128))], 4)) : Object(external_commonjs_vue_commonjs2_vue_root_Vue_["createCommentVNode"])("", true)];
  })], 4);
}
// CONCATENATED MODULE: ./src/components/Donut.vue?vue&type=template&id=b088dc58

// CONCATENATED MODULE: ./src/utils/events.js
var nativeSectionEvents = ['click', 'mouseenter', 'mouseleave', 'mouseover', 'mouseout', 'mousemove'].map(function (nativeEventName) {
  return {
    nativeEventName: nativeEventName,
    sectionEventName: "section-".concat(nativeEventName)
  };
});
// CONCATENATED MODULE: ./src/utils/colors.js
var colors = ['#FF6384', '#36A2EB', '#FFCE56', '#F58231', '#46F0F0', '#D2F53C', '#911EB4', '#F032E6', '#3CB44B', '#FFE119', '#E6194B', '#FABEBE', '#008080', '#E6BEFF', '#0082C8', '#AA6E28', '#FFFAC8', '#800000', '#AAFFC3', '#808000', '#FFD8B1', '#000080', '#808080', '#000000'];
/* harmony default export */ var utils_colors = (colors);
// CONCATENATED MODULE: ./src/utils/misc.js
var _placementStyles;

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var legendGap = '1em';
var defaultColor = 'dodgerblue';
var placement = {
  TOP: 'top',
  RIGHT: 'right',
  BOTTOM: 'bottom',
  LEFT: 'left'
};
var misc_placementStyles = (_placementStyles = {}, _defineProperty(_placementStyles, placement.TOP, {
  container: {
    flexDirection: 'column'
  },
  legend: {
    order: -1,
    margin: 0,
    marginBottom: legendGap
  }
}), _defineProperty(_placementStyles, placement.RIGHT, {
  container: {},
  legend: {
    flexDirection: 'column',
    margin: 0,
    marginLeft: legendGap
  }
}), _defineProperty(_placementStyles, placement.BOTTOM, {
  container: {
    flexDirection: 'column'
  },
  legend: {}
}), _defineProperty(_placementStyles, placement.LEFT, {
  container: {},
  legend: {
    flexDirection: 'column',
    order: -1,
    margin: 0,
    marginRight: legendGap
  }
}), _placementStyles);

var isObject = function isObject(obj) {
  return !!obj && obj.constructor === Object;
};

var sectionKeys = [{
  type: 'number',
  key: 'value',
  required: true
}, {
  key: 'label'
}, {
  key: 'color'
}];
function sectionValidator(section) {
  if (!isObject(section)) return false;
  return sectionKeys.reduce(function (acc, curr) {
    if (!acc) return false;
    var valid = true;
    if (curr.required) valid = valid && Object.hasOwnProperty.call(section, curr.key);
    if (curr.type) valid = valid && _typeof(section[curr.key]) === curr.type;
    return acc && valid;
  }, true);
}
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vue-loader-v16/dist/templateLoader.js??ref--6!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader-v16/dist??ref--0-1!./src/components/DonutSections.vue?vue&type=template&id=12a44aa8

var DonutSectionsvue_type_template_id_12a44aa8_hoisted_1 = ["title"];
function DonutSectionsvue_type_template_id_12a44aa8_render(_ctx, _cache, $props, $setup, $data, $options) {
  return Object(external_commonjs_vue_commonjs2_vue_root_Vue_["openBlock"])(), Object(external_commonjs_vue_commonjs2_vue_root_Vue_["createElementBlock"])("div", {
    class: "cdc-sections",
    style: Object(external_commonjs_vue_commonjs2_vue_root_Vue_["normalizeStyle"])($options.containerStyles)
  }, [(Object(external_commonjs_vue_commonjs2_vue_root_Vue_["openBlock"])(true), Object(external_commonjs_vue_commonjs2_vue_root_Vue_["createElementBlock"])(external_commonjs_vue_commonjs2_vue_root_Vue_["Fragment"], null, Object(external_commonjs_vue_commonjs2_vue_root_Vue_["renderList"])($options.donutSections, function (section, idx) {
    return Object(external_commonjs_vue_commonjs2_vue_root_Vue_["openBlock"])(), Object(external_commonjs_vue_commonjs2_vue_root_Vue_["createElementBlock"])("div", Object(external_commonjs_vue_commonjs2_vue_root_Vue_["mergeProps"])(Object(external_commonjs_vue_commonjs2_vue_root_Vue_["toHandlers"])(section.listeners), {
      key: idx,
      class: ["cdc-section", section.className],
      style: section.sectionStyles
    }), [Object(external_commonjs_vue_commonjs2_vue_root_Vue_["createElementVNode"])("div", {
      class: "cdc-filler",
      style: Object(external_commonjs_vue_commonjs2_vue_root_Vue_["normalizeStyle"])(section.fillerStyles),
      title: section.label
    }, null, 12, DonutSectionsvue_type_template_id_12a44aa8_hoisted_1)], 16);
  }), 128))], 4);
}
// CONCATENATED MODULE: ./src/components/DonutSections.vue?vue&type=template&id=12a44aa8

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader-v16/dist??ref--0-1!./src/components/DonutSections.vue?vue&type=script&lang=js
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { DonutSectionsvue_type_script_lang_js_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function DonutSectionsvue_type_script_lang_js_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var sectionClass = {
  LEFT: 'cdc-section-left',
  RIGHT: 'cdc-section-right'
};
/* harmony default export */ var DonutSectionsvue_type_script_lang_js = ({
  props: {
    startAngle: {
      type: Number,
      default: 0
    },
    sections: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  emits: nativeSectionEvents.map(function (evt) {
    return evt.sectionEventName;
  }),
  computed: {
    containerStyles: function containerStyles() {
      return {
        transform: "rotate(".concat(this.startAngle, "deg)")
      };
    },
    donutSections: function donutSections() {
      var _this = this;

      var maxDegreesPerSection = 180;
      var degreesConsumed = 0;
      var offsetBy = 0;
      var sections = this.sections.map(function (section) {
        var _ref = [sectionClass.RIGHT, -180],
            className = _ref[0],
            offset = _ref[1];

        if (degreesConsumed >= maxDegreesPerSection) {
          var _ref2 = [sectionClass.LEFT, 180];
          className = _ref2[0];
          offset = _ref2[1];
        }

        var degree = offset + section.degree;
        var fillerStyles = {
          backgroundColor: section.color || defaultColor,
          transform: "rotate(".concat(degree, "deg)")
        };
        var sectionStyles = {
          transform: "rotate(".concat(offsetBy, "deg)")
        };
        degreesConsumed += section.degree;
        if (degreesConsumed === 180) offsetBy = 0;else offsetBy += section.degree;
        var listeners = nativeSectionEvents.reduce(function (acc, _ref3) {
          var nativeEventName = _ref3.nativeEventName,
              sectionEventName = _ref3.sectionEventName;
          return _objectSpread(_objectSpread({}, acc), {}, DonutSectionsvue_type_script_lang_js_defineProperty({}, nativeEventName, function (event) {
            return _this.emitEvent(sectionEventName, section, event);
          }));
        }, {});
        return {
          label: section.label,
          className: className,
          fillerStyles: fillerStyles,
          sectionStyles: sectionStyles,
          listeners: listeners
        };
      });
      return sections;
    }
  },
  methods: {
    emitEvent: function emitEvent(sectionEventName, section, event) {
      if (section.value === 0) return;
      this.$emit(sectionEventName, section.$section, event);
    }
  }
});
// CONCATENATED MODULE: ./src/components/DonutSections.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./node_modules/vue-loader-v16/dist/exportHelper.js
var exportHelper = __webpack_require__("6b0d");
var exportHelper_default = /*#__PURE__*/__webpack_require__.n(exportHelper);

// CONCATENATED MODULE: ./src/components/DonutSections.vue





const __exports__ = /*#__PURE__*/exportHelper_default()(DonutSectionsvue_type_script_lang_js, [['render',DonutSectionsvue_type_template_id_12a44aa8_render]])

/* harmony default export */ var DonutSections = (__exports__);
// EXTERNAL MODULE: ./src/styles/main.css
var main = __webpack_require__("7e79");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader-v16/dist??ref--0-1!./src/components/Donut.vue?vue&type=script&lang=js
function Donutvue_type_script_lang_js_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function Donutvue_type_script_lang_js_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { Donutvue_type_script_lang_js_ownKeys(Object(source), true).forEach(function (key) { Donutvue_type_script_lang_js_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { Donutvue_type_script_lang_js_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function Donutvue_type_script_lang_js_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






/* harmony default export */ var Donutvue_type_script_lang_js = ({
  name: 'vc-donut',
  props: {
    // diameter of the donut
    size: {
      type: Number,
      default: 250,
      validator: function validator(v) {
        return v > 0;
      }
    },
    // unit to use for `size`
    unit: {
      type: String,
      default: 'px'
    },
    // percentage of donut ring's thickness
    thickness: {
      type: Number,
      default: 20,
      validator: function validator(v) {
        return v >= 0 && v <= 100;
      }
    },
    // text in the middle of the donut, this can also be passed using the default slot
    text: {
      type: String,
      default: null
    },
    autoAdjustTextSize: {
      type: Boolean,
      default: true
    },
    // color to use for the middle of the donut
    // set this to `transparent` or `thickness` to 100 to make a pie chart instead
    background: {
      type: String,
      default: '#ffffff'
    },
    // color to use for the empty ring areas
    foreground: {
      type: String,
      default: '#eeeeee'
    },
    // sections of the donut, must have a `value` property
    // other valid properties are `label` and `color` (default is `dodgerblue`)
    sections: {
      type: Array,
      default: function _default() {
        return [];
      },
      validator: function validator(sections) {
        for (var i = 0; i < sections.length; ++i) {
          /* istanbul ignore if - already covered by unit tests for sectionValidator */
          if (!sectionValidator(sections[i])) return false;
        }

        return true;
      }
    },
    total: {
      type: Number,
      default: 100,
      validator: function validator(v) {
        return v > 0;
      }
    },
    hasLegend: {
      type: Boolean,
      default: false
    },
    legendPlacement: {
      type: String,
      default: placement.BOTTOM,
      validator: function validator(val) {
        return !!placement[val.toUpperCase()];
      }
    },
    // degree angle at which the first section begins
    startAngle: {
      type: Number,
      default: 0
    }
  },
  emits: nativeSectionEvents.map(function (evt) {
    return evt.sectionEventName;
  }),
  watch: {
    autoAdjustTextSize: function autoAdjustTextSize(val) {
      if (val) window.addEventListener('resize', this.resizeListener);else window.removeEventListener('resize', this.resizeListener);
      this.recalcFontSize();
    },
    size: function size() {
      this.recalcFontSize();
    },
    unit: function unit() {
      this.recalcFontSize();
    }
  },
  data: function data() {
    return {
      donutEl: null,
      fontSize: '1em',
      resizeListener: null
    };
  },
  computed: {
    donutSections: function donutSections() {
      var _this = this;

      var valueTotal = this.sections.reduce(function (a, c) {
        return a + c.value;
      }, 0);
      if (typeof valueTotal !== 'number') return [];
      valueTotal = Number(valueTotal.toFixed(2));

      if (valueTotal > this.total) {
        var err = "Sum of all the sections' values (".concat(valueTotal, ") should not exceed `total` (").concat(this.total, ")");
        throw new Error(err);
      }

      var degreesInACircle = 360;
      var degreesInASection = 180;
      var consumedDegrees = 0;
      var currentDefaultColorIdx = 0;
      var sections = [];
      this.sections.forEach(function (section) {
        var valToDeg = degreesInACircle * (section.value / _this.total);
        var degreeArr = [valToDeg];

        if (valToDeg > degreesInASection) {
          degreeArr = [degreesInASection, valToDeg - degreesInASection];
        }

        var color = section.color || utils_colors[currentDefaultColorIdx++];
        degreeArr.forEach(function (degree) {
          // limit to 2 decimal digits to avoid floating point arithmetic issues
          var consumedWithCurrent = Number((consumedDegrees + degree).toFixed(2));

          if (consumedWithCurrent > degreesInASection) {
            var remainingDegreesInCurrentSection = degreesInASection - consumedDegrees;
            sections.push(Donutvue_type_script_lang_js_objectSpread(Donutvue_type_script_lang_js_objectSpread({}, section), {}, {
              degree: remainingDegreesInCurrentSection,
              color: color,
              $section: section
            }), Donutvue_type_script_lang_js_objectSpread(Donutvue_type_script_lang_js_objectSpread({}, section), {}, {
              degree: degree - remainingDegreesInCurrentSection,
              color: color,
              $section: section
            }));
          } else {
            sections.push(Donutvue_type_script_lang_js_objectSpread(Donutvue_type_script_lang_js_objectSpread({}, section), {}, {
              degree: degree,
              color: color,
              $section: section
            }));
          }

          consumedDegrees += degree;

          if (consumedDegrees >= degreesInASection) {
            consumedDegrees -= degreesInASection;
          }
        });
      });
      return sections;
    },
    legend: function legend() {
      var _this2 = this;

      /* istanbul ignore if - legend isn't rendered at all because of v-if="hasLegend" */
      if (!this.hasLegend) return null;
      var currentDefaultColorIdx = 0;
      return this.sections.map(function (section, idx) {
        return {
          label: section.label || "Section ".concat(idx + 1),
          percent: "".concat(section.value, " (").concat(section.value / _this2.total * 100, "%)"),
          styles: {
            backgroundColor: section.color || utils_colors[currentDefaultColorIdx++]
          }
        };
      });
    },
    placementStyles: function placementStyles() {
      if (!this.hasLegend) return {};
      return misc_placementStyles[this.legendPlacement];
    },
    donutStyles: function donutStyles() {
      var size = "".concat(this.size).concat(this.unit);
      var styles = {
        width: size,
        paddingBottom: size,
        backgroundColor: this.foreground
      };
      return styles;
    },
    overlayStyles: function overlayStyles() {
      var availablePercent = 100;
      var size = availablePercent - this.thickness;
      var sizePercent = "".concat(size, "%");
      var pos = "calc(50% - ".concat(size / 2, "%)");
      return {
        height: sizePercent,
        width: sizePercent,
        top: pos,
        left: pos,
        backgroundColor: this.background
      };
    },
    donutTextStyles: function donutTextStyles() {
      var fontSize = this.fontSize;
      return {
        fontSize: fontSize
      };
    },
    sectionListeners: function sectionListeners() {
      var _this3 = this;

      return nativeSectionEvents.reduce(function (acc, _ref) {
        var sectionEventName = _ref.sectionEventName;
        return Donutvue_type_script_lang_js_objectSpread(Donutvue_type_script_lang_js_objectSpread({}, acc), {}, Donutvue_type_script_lang_js_defineProperty({}, sectionEventName, function () {
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          return _this3.emitSectionEvent.apply(_this3, [sectionEventName].concat(args));
        }));
      }, {});
    }
  },
  methods: {
    recalcFontSize: function recalcFontSize() {
      var _this4 = this;

      if (!this.autoAdjustTextSize) {
        this.fontSize = '1em';
        return;
      }

      var scaleDownBy = 0.08;
      var widthInPx = this.size;
      this.$nextTick(function () {
        if (_this4.unit !== 'px') {
          /* istanbul ignore else */
          if (_this4.donutEl) widthInPx = _this4.donutEl.clientWidth;else widthInPx = null;
        }

        _this4.fontSize = widthInPx ? "".concat((widthInPx * scaleDownBy).toFixed(2), "px") : '1em';
      });
    },
    emitSectionEvent: function emitSectionEvent(sectionEventName) {
      for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }

      this.$emit.apply(this, [sectionEventName].concat(args));
    }
  },
  created: function created() {
    this.resizeListener = this.recalcFontSize.bind(this);
  },
  mounted: function mounted() {
    this.donutEl = this.$refs.donut;

    if (this.autoAdjustTextSize) {
      this.recalcFontSize();
      window.addEventListener('resize', this.resizeListener);
    }
  },
  beforeUnmount: function beforeUnmount() {
    window.removeEventListener('resize', this.resizeListener);
  },
  components: {
    DonutSections: DonutSections
  }
});
// CONCATENATED MODULE: ./src/components/Donut.vue?vue&type=script&lang=js
 
// CONCATENATED MODULE: ./src/components/Donut.vue





const Donut_exports_ = /*#__PURE__*/exportHelper_default()(Donutvue_type_script_lang_js, [['render',render]])

/* harmony default export */ var Donut = (Donut_exports_);
// CONCATENATED MODULE: ./src/index.js

var DonutPlugin = {
  install: function install(app) {
    app.component(Donut.name, Donut);
  }
};
/* harmony default export */ var src_0 = (DonutPlugin);
// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/entry-lib.js


/* harmony default export */ var entry_lib = __webpack_exports__["default"] = (src_0);



/***/ })

/******/ });